<template>
  <g>
    <path
      d="M12 16.0002C15.87 16.0002 19 12.8702 19 9.00024C19 5.13024 15.87 2.00024 12 2.00024C8.13 2.00024 5 5.13024 5 9.00024C5 12.8702 8.13 16.0002 12 16.0002ZM12 4.00024C14.76 4.00024 17 6.24024 17 9.00024C17 11.7602 14.76 14.0002 12 14.0002C9.24 14.0002 7 11.7602 7 9.00024C7 6.24024 9.24 4.00024 12 4.00024Z"
    />
    <path
      d="M10 9.00024C10.5523 9.00024 11 8.55253 11 8.00024C11 7.44796 10.5523 7.00024 10 7.00024C9.44772 7.00024 9 7.44796 9 8.00024C9 8.55253 9.44772 9.00024 10 9.00024Z"
    />
    <path
      d="M14 9.00024C14.5523 9.00024 15 8.55253 15 8.00024C15 7.44796 14.5523 7.00024 14 7.00024C13.4477 7.00024 13 7.44796 13 8.00024C13 8.55253 13.4477 9.00024 14 9.00024Z"
    />
    <path
      d="M12 7.00024C12.5523 7.00024 13 6.55253 13 6.00024C13 5.44796 12.5523 5.00024 12 5.00024C11.4477 5.00024 11 5.44796 11 6.00024C11 6.55253 11.4477 7.00024 12 7.00024Z"
    />
    <path
      d="M16 17.0002H8C7.45 17.0002 7 17.4502 7 18.0002C7 18.5502 7.45 19.0002 8 19.0002H9C10.1 19.0002 11 19.9002 11 21.0002V22.0002H13V21.0002C13 19.9002 13.9 19.0002 15 19.0002H16C16.55 19.0002 17 18.5502 17 18.0002C17 17.4502 16.55 17.0002 16 17.0002Z"
    />
  </g>
</template>
